/*@jsxRuntime automatic*/
/*@jsxImportSource react*/
import {useMDXComponents as _provideComponents} from "nextra/mdx";
const title = "Classic Panels";
const frontMatter = {};
import {Alert} from '@/components';
export function useTOC(props) {
  return [];
}
function MDXLayout(props) {
  const _components = {
    a: "a",
    p: "p",
    ..._provideComponents(),
    ...props.components
  };
  return <Alert severity="info"><_components.p><_components.a href="/observe/dashboards/classic-dashboards">{"Classic dashboards"}</_components.a>{" have their own panels\nand methods of configuring them. For details about panels in classic dashboards,\nsee "}<_components.a href="/observe/dashboards/classic-dashboards/classic-panels">{"Classic dashboard panels"}</_components.a>{"."}</_components.p></Alert>;
}

export default MDXLayout